import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import actions from "./actions";
export var toggleDrawer = name => ( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleDrawer(name));
  });
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export var closeDrawer = () => ( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleDrawer(null));
  });
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
export var setFooterVisible = toggle => ( /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setFooterVisible(toggle));
  });
  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());

/** @deprecated */
export var toggleSearch = () => ( /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleSearch());
  });
  return function (_x4) {
    return _ref4.apply(this, arguments);
  };
}());